export default __webpack_public_path__ + "static/media/livingroom2.49a006c9.webp";